import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import {
  getArticlesByText,
  getHomePageTrendingArticles,
  getMobileAppBanner,
  HOME_PAGE_ARTICLES_BY_TEXT_TAGS,
  HOME_PAGE_TRENDING_ARTICLES_TAGS,
  MOBILE_APP_BANNER_TAGS,
} from './endpoints';

const articlesApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getHomePageTrendingArticles: getHomePageTrendingArticles(builder),
      getArticlesByText: getArticlesByText(builder),
      getMobileAppBanner: getMobileAppBanner(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [HOME_PAGE_TRENDING_ARTICLES_TAGS, HOME_PAGE_ARTICLES_BY_TEXT_TAGS, MOBILE_APP_BANNER_TAGS],
  });

export const { useGetHomePageTrendingArticlesQuery, useGetArticlesByTextQuery, useGetMobileAppBannerQuery } =
  articlesApi;
